<template>
  <v-dropdown class="c-sort">
    <template #activator>
      <i class="o-icon o-icon--sort"></i>
      <div class="c-sort__triangle"></div>
      <div class="o-typography__subtitle1">
        {{ currentOption.label }}
      </div>
    </template>
    <template v-for="(sortingOption, index) in availableOptions">
      <div
        v-if="!checkOption(sortingOption)"
        :key="index"
        v-accessibility-focus="() => updateOption(sortingOption)"
        class="o-typography--action u-color-primary"
      >
        {{ sortingOption.label }}
      </div>
    </template>
  </v-dropdown>
</template>

<script>
  import { VDropdown } from '@/index/shared/components';
  import { SortType } from '@/shared/enums';

  export default {
    components: {
      VDropdown,
    },
    props: {
      disabledSortOptions: {
        type: Array,
        default: () => [],
      },
      resource: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        sortingOptions: [
          {
            id: SortType.SINCE_DESC,
            label: this.$t('glossary.newest'),
            sort: 'since',
            order: 'desc',
          },
          {
            id: SortType.SINCE_ASC,
            label: this.$t('glossary.oldest'),
            sort: 'since',
            order: 'asc',
          },
          {
            id: SortType.YEAR_DESC,
            label: this.$t('glossary.newestYear'),
            sort: 'year',
            order: 'desc',
          },
          {
            id: SortType.YEAR_ASC,
            label: this.$t('glossary.oldestYear'),
            sort: 'year',
            order: 'asc',
          },
          {
            id: SortType.CREATED_AT_DESC,
            label: this.$t('glossary.newlyAdd'),
            sort: 'createdAt',
            order: 'desc',
          },
        ],
      };
    },
    computed: {
      currentOption() {
        return this.storageOption || this.defaultOption || this.availableOptions[0];
      },
      storageOption() {
        const sortingStoragedOption = this.$storage.sortOption;
        return sortingStoragedOption && this.availableOptions.find((sortingOption) => this.checkOption(sortingStoragedOption, sortingOption));
      },
      defaultOption() {
        const { defaultSortField, defaultSortOrder } = this.resource;
        return this.availableOptions.find((sortingOption) => this.checkOption({ sort: defaultSortField, order: defaultSortOrder }, sortingOption));
      },
      availableOptions() {
        return this.sortingOptions.filter(({ id }) => !this.disabledSortOptions.includes(id));
      },
    },
    methods: {
      updateOption(sortingOption) {
        this.$storage.sortOption = {
          order: sortingOption.order,
          sort: sortingOption.sort,
        };

        this.$router.reload();
      },
      checkOption(checkingOption, option = this.currentOption) {
        return option.order === checkingOption.order && option.sort === checkingOption.sort;
      },
    },
  };
</script>
